import React, { useMemo, useState } from 'react';
import { LuPlusCircle } from 'react-icons/lu';
import { Tabs } from 'components/Tabs';
import { PageHeader } from 'components/PageHeader';
import { Heading1 } from 'components/Heading1';
import { PageWrapper } from 'components/PageWrapper';
import {
	DebitCollectionsIcon,
	DebitCollectionsRoutes,
} from './constants/routes';
import { BreadcrumbContainer } from 'components/Breadcrumb';
import { PageActions } from 'components/PageActions';
import { Button } from 'antd';
import { useCurrentProfile } from 'modules/core/context/ProfileContext';
import { AccessPermission, AccessType } from 'types/Access';
import { TabElement } from 'components/Tabs/Tabs';
import { Collections } from './pages/Collections';
import { WalletCreation } from './components/WalletCreation';
import CnabList from './pages/CnabList/CnabList';
import { DebitCollectionsSummary } from './components/DebitCollectionsSummary';
import { AllCharges } from './pages/AllCharges';
import theme from 'theme/theme';
import { BsArrowBarUp } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import { CnabImportModal } from './components/CnabImport';

const DebitCollectionsPage = () => {
	const [isWalletCreationOpen, setIsWalletCreationOpen] =
		useState<boolean>(false);
	const { type, permissions } = useCurrentProfile();
	const navigate = useNavigate();
	const [isCnabImportModalOpen, setIsCnabImportModalOpen] = useState(false);

	const tabElements = useMemo<TabElement[]>(() => {
		const tabs = [
			{
				title: 'Carteiras',
				content: <Collections />,
				path: 'collections',
				breadcrumb: [
					{
						href: DebitCollectionsRoutes.BASE,
						title: (
							<BreadcrumbContainer>
								<DebitCollectionsIcon />
								<span>Carteiras de cobranças</span>
							</BreadcrumbContainer>
						),
					},
				],
			},
			{
				title: 'Arquivos de retorno',
				content: <CnabList />,
				path: 'cnab-list',
				breadcrumb: [
					{
						href: DebitCollectionsRoutes.BASE,
						title: (
							<BreadcrumbContainer>
								<DebitCollectionsIcon />
								<span>Arquivos de retorno</span>
							</BreadcrumbContainer>
						),
					},
				],
			},
			{
				title: 'Cobranças',
				content: <AllCharges />,
				path: 'all-charges',
				breadcrumb: [
					{
						href: DebitCollectionsRoutes.CHARGES,
						title: (
							<BreadcrumbContainer>
								<DebitCollectionsIcon />
								<span>Cobranças</span>
							</BreadcrumbContainer>
						),
					},
				],
			},
		];
		return tabs;
	}, []);

	return (
		<>
			<PageHeader isFluid={true}>
				<Heading1>Carteiras</Heading1>
				{(type === AccessType.FINANCIAL_INSTITUTION ||
					permissions.includes(AccessPermission.CREATE_WALLET)) && (
					<PageActions>
						<Button
							type="primary"
							onClick={() => setIsWalletCreationOpen(true)}
						>
							Nova carteira de cobrança
							<LuPlusCircle
								style={{ marginLeft: '0.6rem' }}
								size={18}
							/>
						</Button>
						{type !== AccessType.FINANCIAL_INSTITUTION &&
							permissions.includes(
								AccessPermission.CREATE_CHARGE,
							) && (
								<Button
									style={{
										color: theme.primary,
									}}
									type="default"
									onClick={() =>
										setIsCnabImportModalOpen(true)
									}
								>
									Upload de CNAB
									<BsArrowBarUp
										style={{ marginLeft: '0.6rem' }}
										size={18}
									/>
								</Button>
							)}
					</PageActions>
				)}
			</PageHeader>

			<PageWrapper isFluid={true}>
				<DebitCollectionsSummary />
				<Tabs elements={tabElements} />
			</PageWrapper>
			<WalletCreation
				isOpen={isWalletCreationOpen}
				onClose={() => setIsWalletCreationOpen(false)}
			/>
			<CnabImportModal
				isOpen={isCnabImportModalOpen}
				onClose={() => setIsCnabImportModalOpen(false)}
			/>
		</>
	);
};

export default DebitCollectionsPage;
